import regular from 'shido.regular.js/src/regular.js'

class getGallery {
  constructor() {
    this.$button  = document.querySelector('.btn--get-more')
    this.$filters = document.querySelectorAll('[name="category-picker"]')
  }

  _get(category) {
    this.$button.classList.add('pending')
    const self = this
    let number = $('.image:visible').length
    axios.post('/galeria/mas', {
      number: number,
      category: category
    })
    .then(function (response) {
      $('[appender]').append(response.data)

      let $last = $('[data-blocks]:last-of-type')
      let result = $last.attr('data-blocks')
      $last.hide().fadeIn(500)

      if( parseInt(result) < 6 ){
        $(self.$button).fadeOut(200)
      }else{
        $(self.$button).fadeIn(200)
      }
      setTimeout(() => {
        new regular().init();
      }, 500)
    })
    .catch(function (error) {
      console.log('Error al consultar la galería');
    })
    .then(function () {
      self.$button.classList.remove('pending')
    })
  }

  init() {
    if(this.$button !== null) {
      this.$button.addEventListener('click', (event) => {
        event.preventDefault()
        // --
        let category = (this.$filters.length > 0) ? document.querySelector('[name="category-picker"]:checked').value : 'all'
        this._get(category)
      })
    }

    if(this.$filters.length > 0) {
      this.$filters.forEach(($filter) => {
        $filter.addEventListener('change', () => {
          let category = $filter.value
          document.querySelectorAll('.gallery-blocks').forEach(function($item) {
            $item.remove()
          })
          this._get(category)
        })
      })
    }
  }
}
export default getGallery
